import { useApi } from '@/api';
import { HomeCarousel, Page } from '@/components';
import { Flex, FlexProps } from '@blockanalitica/ui';
import styled, { css } from 'styled-components';
import SavingsCard from './SavingsCard';
import SLLCard from './SLLCard';
import SparkLendCard from './SparkLendCard';
import StakingCard from './StakingCard';

const HeaderText = styled(Flex)<FlexProps>`
  font-weight: 500;

  ${(props) => css`
    font-size: ${props.theme.sizes['6']};
    padding-top: ${props.theme.sizes['8']};
  `}
`;

type HomeResponse = Record<string, any>;

export default function HomePage() {
  const [data, error, isLoading] = useApi<HomeResponse>({
    url: '/sparkstar/',
    queryParams: {}
  });

  return (
    <Page>
      <Flex flexDirection="column">
        <HeaderText>Spark Data Hub</HeaderText>
        <Flex as="p" color="muted" paddingTop="s">
          Your gateway to understanding the mechanics behind Spark.
          <br />
          This platform offers real-time insights into savings and lending
          activity powered by Spark.
        </Flex>
      </Flex>
      <Flex paddingTop="l" paddingBottom="xl">
        <HomeCarousel>
          <SLLCard data={data} error={error} isLoading={isLoading} />
          <SavingsCard data={data} error={error} isLoading={isLoading} />
          <SparkLendCard data={data} error={error} isLoading={isLoading} />
          {/* <SPKTokenCard data={data} error={error} isLoading={isLoading} /> */}
          <StakingCard data={data} error={error} isLoading={isLoading} />
        </HomeCarousel>
      </Flex>
    </Page>
  );
}
